export default "__VITE_ASSET__D$5gkX8p__"